import EmployeeSalaryIncomDeductionComponents from "../components/EmployeeSalaryIncomDeduction";
import useEmployeeSalaryIncomDeduction from "../hooks/useEmployeeSalaryIncomDeduction";

function EmployeeSalaryIncomDeduction() {
  const employeeSalaryIncomDeductionProps = useEmployeeSalaryIncomDeduction();
  return (
    <EmployeeSalaryIncomDeductionComponents
      {...employeeSalaryIncomDeductionProps}
    />
  );
}

export default EmployeeSalaryIncomDeduction;
